












































































import Vue from "vue";
import Filters from "@/vue/components/filters.vue";
import ResultTable from "@/vue/components/result_table.vue";
import Timeline from "../components/Timeline.vue";

export default Vue.extend({
  name: "App",
  components: { Filters, ResultTable, Timeline },
  data: () => ({
    breadcrumbItems: [
      {
        text: "Inicio",
        disabled: false,
        to: "/",
      },
      {
        text: "Muestreo Proporción de Especies",
        disabled: true,
        to: "/pn_mueproesp",
      },
    ],
    listTimeline: [
      {
        right: false,
        title: "Muestreo de Proporción de Especies",
        year: "1968",
        description:
          "Se comienzan a recoger información de la composición de especies en frecuencia y peso de una muestra tomada, el cual puede ser realizado a bordo de las naves o en tierra.",
      },
      {
        right: true,
        title: "Datos Disponibles",
        year: "2020",
        description:
          "Los datos recopilados de bitácoras y muestreos recopilados en la plataforma abarcan hasta el 30 de Diciembre del 2020.",
      },
    ],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
});
